import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, TextField, useEntityManager, Checkbox } from 'elentari'
import centrosCustoRepository from './CentrosCustoRepository'
import EmpresaSelect from '../Empresa/EmpresaSelect'
import UnidadeNegocioAutocomplete from '../UnidadeNegocio/UnidadeNegocioAutocomplete'

const CentroCustoForm = props => {
  const entityManager = useEntityManager({ repository: centrosCustoRepository })
  const initialValuesFormatter = item => {
    if (entityManager.isNew) {
      item.ativo = true
    }
  }

  const handleSubmit = data => {
    delete data.empresa
    return entityManager.onSubmit({
      ...data,
      idExterno: data.idExterno ? data.idExterno : undefined
    })
  }
  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      initialValues={initialValuesFormatter(entityManager.item)}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <EmpresaSelect />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="unidadeNegocioId"
            label="Unidade de Negocio"
            component={UnidadeNegocioAutocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="ativo"
            label="Ativo"
            component={Checkbox}
            type="checkbox"
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default CentroCustoForm
